import { useEffect } from 'react';

interface Props {
  initForm(): void;
  initTimezones(): Promise<void>;
}

export const useEditSendoutsEffects = ({ initForm, initTimezones }: Props) => {
  useEffect(() => {
    initForm();
  }, [initForm]);

  useEffect(() => {
    initTimezones();
  }, [initTimezones]);
};
